import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Image, Card } from "react-bootstrap";
import { useAuth } from "../AuthContext";
import Carga from "../componentes/cargando/Cargando";
import { useNavigate, useParams, Outlet } from "react-router-dom";
import { buscarCategoriaServicio } from "../service/productos/obtenerCategoriasService";
import { obtenerProducto } from "../service/productos/obtenerProductoServicio";
import { formatearAPesos } from "../helpers/formatos";
import Swal from "sweetalert2";
import { FaTrashAlt } from "react-icons/fa";
import { useDropzone } from "react-dropzone";
import {
    mensajeError,
    mensajeErrorNoAutorizado,
    mensajeErrorPersonalizado,
    mensajeErrorSesion
} from "../helpers/mensajesSwalError";
import { mensajeExitoCargando, mesanjeExitoPersonalizado } from "../helpers/mensajesSwalExito";
import { editarProductoServicio } from "../service/productos/editarProductoService";
import ModalProductosBodegasEditar from "./modalProductoBodegasEditar";
import { buscarBodegasService } from "../service/bodegas/bodegasService";
import {buscarStockProductoServicio, editarStockProductoServicio} from "../service/bodegas/stockBodegaService";

const FormularioEditarProducto = () => {
    const navigate = useNavigate();
    const { verificacionToken, removerLocalStorage } = useAuth();
    const { id } = useParams();

    const [cargando, setCargando] = useState(true);
    const [categorias, setCategorias] = useState([]);
    const [producto, setProducto] = useState({
        nombre: "",
        precio: "",
        stock: "",
        descripcion: "",
        categoriaId: "",
        imagenes: [],
        imagenesViejas: []
    });
    const [previewImages, setPreviewImages] = useState([]);
    const [modalAddOpen, setModalAddOpen] = useState(false);

    // Siempre como objeto con stockBodegas
    const [listaStockProductos, setListaStockProductos] = useState({
        stockBodegas: []
    });

    const [bodegas, setBodegas] = useState([]);

    const abrirModalAdd = () => {
        setListaStockProductos(prev => ({
            stockBodegas:
                prev.stockBodegas.length > 0
                    ? prev.stockBodegas
                    : bodegas.map(b => ({
                        bodegaId: b.id,
                        stock: 0
                    }))
        }));
        setModalAddOpen(true);
    };

    const cerrarModalAdd = () => setModalAddOpen(false);

    // -------------------- Cargar Categorías --------------------
    const cargarCategoria = async () => {
        try {
            const categoriasBD = await buscarCategoriaServicio();
            if (!categoriasBD[0]) {
                if (categoriasBD[3] === 401) {
                    removerLocalStorage();
                    mensajeErrorSesion();
                } else if (categoriasBD[3] === 403) {
                    removerLocalStorage();
                    mensajeErrorNoAutorizado();
                } else {
                    removerLocalStorage();
                    mensajeError();
                }
            } else {
                setCategorias(categoriasBD[1]);
            }
        } catch (error) {
            console.error("Error cargando categorías:", error);
            mensajeError();
        }
    };

    // -------------------- Cargar producto --------------------
    const cargarProducto = async () => {
        try {
            const respuesta = await obtenerProducto(id);
            if (!respuesta[0]) {
                mensajeErrorPersonalizado(respuesta[2]);
                navigate("/productos");
            } else {
                const data = respuesta[1];
                setProducto(prev => ({
                    ...prev,
                    nombre: data.nombre,
                    precio: data.precio,
                    stock: data.stock,
                    descripcion: data.descripcion,
                    categoriaId: data.categoria_id,
                    imagenesViejas: data.paths_productos || []
                }));
            }
        } catch (error) {
            console.error("Error cargando producto:", error);
            mensajeError();
        } finally {
            setCargando(false);
        }
    };

    const cargarBodegas = async () => {
        const respuesta = await buscarBodegasService();
        if (!respuesta[0]) {
            if (respuesta[3] === 401) {
                removerLocalStorage();
                mensajeErrorSesion();
            } else if (respuesta[3] === 403) {
                removerLocalStorage();
                mensajeErrorNoAutorizado();
            } else {
                removerLocalStorage();
                mensajeError();
            }
        } else {
            setBodegas(respuesta[1]);
        }
    };

    const buscarStockProductos = async () => {
        const respuesta = await buscarStockProductoServicio(id);
        if (!respuesta[0]) {
            if (respuesta[2] === 401) {
                removerLocalStorage();
                mensajeErrorSesion();
            } else if (respuesta[2] === 403) {
                removerLocalStorage();
                mensajeErrorNoAutorizado();
            } else {
                removerLocalStorage();
                mensajeError();
            }
        } else {
            setListaStockProductos({
                stockBodegas: respuesta[1].map(s => ({
                    bodegaId: s.bodegas_id,
                    stock: Number(s.stock)
                }))
            });
        }
    };

    useEffect(() => {
        verificacionToken("ROLE_DUENO");
        cargarCategoria();
        cargarProducto();
        cargarBodegas();
        buscarStockProductos();
    }, []);

    // -------------------- Dropzone --------------------
    const onDrop = acceptedFiles => {
        const files = [...producto.imagenes, ...acceptedFiles].slice(0, 5);
        setProducto({ ...producto, imagenes: files });
        const previews = files.map(file => URL.createObjectURL(file));
        setPreviewImages(previews);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { "image/*": [] },
        maxFiles: 5
    });

    if (cargando) return <Carga />;

    // -------------------- Handlers --------------------
    const handleChange = e => {
        const { name, value } = e.target;
        setProducto({ ...producto, [name]: value });
    };

    const removeNewImage = index => {
        const newFiles = [...producto.imagenes];
        newFiles.splice(index, 1);
        setProducto({ ...producto, imagenes: newFiles });

        const newPreviews = [...previewImages];
        newPreviews.splice(index, 1);
        setPreviewImages(newPreviews);
    };

    const removeOldImage = index => {
        const viejas = [...producto.imagenesViejas];
        viejas.splice(index, 1);
        setProducto({ ...producto, imagenesViejas: viejas });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        Swal.fire({
            title: "Estas seguro?",
            text: "Editar Producto!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Actualizar!"
        }).then(async result => {
            if (result.isConfirmed) {
                mensajeExitoCargando();
                await editarProducto();
            }
        });
    };

    const generarNombreUnico = file => {
        const parts = file.name.split(".");
        const extension = parts[parts.length - 1].toLowerCase();
        const timestamp = Date.now();
        const random = Math.random().toString(36).substring(2, 10);
        return `${timestamp}-${random}.${extension}`;
    };

    const editarProducto = async () => {
        const formData = new FormData();
        formData.append("nombre", producto.nombre);
        formData.append("precio", producto.precio);
        formData.append("stock", producto.stock);
        formData.append("descripcion", producto.descripcion);
        formData.append("categoriaId", producto.categoriaId);
        formData.append("imagenesViejas", JSON.stringify(producto.imagenesViejas));

        producto.imagenes.forEach(file => {
            const nombreUnico = generarNombreUnico(file);
            formData.append("imagenes", file, nombreUnico);
        });

        const respuesta = await editarProductoServicio(formData, id);

        if (respuesta[0]) {
            mesanjeExitoPersonalizado("Se editó con éxito el producto");
            navigate("/productos");
        } else {
            mensajeErrorPersonalizado("Ocurrió un error!");
        }
    };

    const actualizarStockBd = async () => {
        const respuesta = await editarStockProductoServicio(id, listaStockProductos.stockBodegas)
        if (!respuesta[0]) {
            if (respuesta[2] === 401) {
                removerLocalStorage();
                mensajeErrorSesion();
            } else if (respuesta[2] === 403) {
                removerLocalStorage();
                mensajeErrorNoAutorizado();
            } else {
                removerLocalStorage();
                mensajeError();
            }
        } else {
            mesanjeExitoPersonalizado("Se editó con éxito el producto");
            navigate("/productos");
        }
    }

    const guardarStockBodega = () => {
        console.log("Stock actualizado:", listaStockProductos.stockBodegas);
        Swal.fire({
            title: "Estas Segura de Solo Actualizar el Stock?",
            text: "Editar Producto!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Actualizar!"
        }).then(async result => {
            if (result.isConfirmed) {
                mensajeExitoCargando();
                await actualizarStockBd()
            }
        });

    };

    // -------------------- Render --------------------
    return (
        <Container className="mt-4 pb-5">
            <Card className="shadow-lg border-0">
                <Card.Header
                    className="text-white"
                    style={{
                        background: "linear-gradient(90deg, #ff9ccf 0%, #d63384 100%)",
                        fontWeight: "bold",
                        fontSize: "1.2rem"
                    }}
                >
                    ✏️ Editar Producto
                </Card.Header>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Nombre del Producto</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nombre"
                                        value={producto.nombre}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Precio</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="precio"
                                        value={formatearAPesos(producto.precio)}
                                        onChange={e => {
                                            const soloNumeros = e.target.value.replace(/\D/g, "");
                                            const numero = Number(soloNumeros) || 0;
                                            setProducto(prev => ({ ...prev, precio: numero }));
                                        }}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="d-flex flex-column justify-content-end align-items-center">
                                <Form.Group className="w-100 d-flex justify-content-center">
                                    <button
                                        type="button"
                                        className="edit-btn m-1"
                                        title="Ingresar Stock"
                                        onClick={abrirModalAdd}
                                    >
                                        Ingresar el Stock
                                    </button>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group className="mb-3">
                            <Form.Label>Categoría</Form.Label>
                            <Form.Select
                                name="categoriaId"
                                value={producto.categoriaId}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Seleccione una categoría</option>
                                {(categorias || []).map(cat => (
                                    <option key={cat.id} value={cat.id}>
                                        {cat.nombre}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Descripción</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="descripcion"
                                value={producto.descripcion}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Imágenes del Producto (máx 5)</Form.Label>
                            <div
                                {...getRootProps()}
                                style={{
                                    border: "2px dashed #d63384",
                                    borderRadius: "8px",
                                    padding: "20px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    backgroundColor: isDragActive ? "#ffe0f0" : "transparent"
                                }}
                            >
                                <input {...getInputProps()} />
                                {isDragActive ? (
                                    <p>Suelta las imágenes aquí...</p>
                                ) : (
                                    <p>Arrastra y suelta tus imágenes o haz click para seleccionarlas</p>
                                )}
                            </div>
                        </Form.Group>

                        <Row className="mb-3 mt-3">
                            {producto.imagenesViejas.map((img, idx) => (
                                <Col key={`vieja-${idx}`} xs={6} md={2} className="mb-2 position-relative">
                                    <Image
                                        src={`${process.env.REACT_APP_API_URL}/uploads/${img.path}`}
                                        thumbnail
                                        style={{ width: "100%", height: "100px", objectFit: "cover" }}
                                    />
                                    <FaTrashAlt
                                        onClick={() => removeOldImage(idx)}
                                        style={{
                                            position: "absolute",
                                            top: "5px",
                                            right: "5px",
                                            color: "white",
                                            backgroundColor: "rgba(0,0,0,0.5)",
                                            borderRadius: "50%",
                                            padding: "2px",
                                            cursor: "pointer"
                                        }}
                                    />
                                </Col>
                            ))}

                            {previewImages.map((img, idx) => (
                                <Col key={`nueva-${idx}`} xs={6} md={2} className="mb-2 position-relative">
                                    <Image
                                        src={img}
                                        thumbnail
                                        style={{ width: "100%", height: "100px", objectFit: "cover" }}
                                    />
                                    <FaTrashAlt
                                        onClick={() => removeNewImage(idx)}
                                        style={{
                                            position: "absolute",
                                            top: "5px",
                                            right: "5px",
                                            color: "white",
                                            backgroundColor: "rgba(0,0,0,0.5)",
                                            borderRadius: "50%",
                                            padding: "2px",
                                            cursor: "pointer"
                                        }}
                                    />
                                </Col>
                            ))}
                        </Row>

                        <Button
                            type="submit"
                            className="text-white mt-2"
                            style={{
                                background: "linear-gradient(90deg, #ff9ccf 0%, #d63384 100%)",
                                border: "none",
                                borderRadius: "8px",
                                fontWeight: "bold"
                            }}
                        >
                            Guardar Cambios
                        </Button>
                    </Form>
                </Card.Body>
            </Card>

            <Outlet />

            <ModalProductosBodegasEditar
                show={modalAddOpen}
                onHide={cerrarModalAdd}
                data={listaStockProductos}
                setData={setListaStockProductos}
                bodegas={bodegas}
                onSave={guardarStockBodega}
            />
        </Container>
    );
};

export default FormularioEditarProducto;